
  const mySwiperProductGrid = new Swiper('.swiper-product-grid', {  
  loop: true,  
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  scrollbar: {
    el: '.swiper-scrollbar',    
  },
});


document.addEventListener("DOMContentLoaded", function () {
  const productTypeEl = document.querySelector('#Product-Type');
  if (!productTypeEl) return;

  const productType = productTypeEl.dataset.productType;
  if (productType !== "オリジナルラベル") return;

  const quantityInput = document.querySelector('#Product-Quantity');
  const plusButton = document.querySelector('button[name="plus"]');
  const minusButton = document.querySelector('button[name="minus"]');

  const step = 49;
  const min = 50;

  if (plusButton && minusButton && quantityInput) {
    plusButton.addEventListener('click', (e) => {
      e.preventDefault();
      const current = parseInt(quantityInput.value) || min;
      quantityInput.value = current + step;
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    });

    minusButton.addEventListener('click', (e) => {
      e.preventDefault();
      const current = parseInt(quantityInput.value) || min;
      if (current > min) {
        quantityInput.value = current - step;
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }
});

// Inputのstepを10に更新
document.addEventListener("DOMContentLoaded", () => {
  const jsInputStep_10 = () => {
    document.querySelectorAll(".jsInputStep-10").forEach(el => {
      if (el.getAttribute("step") !== "10") {
        el.setAttribute("step", "10");
      }
    });
  };
  jsInputStep_10();
  const observerInput = new MutationObserver(() => jsInputStep_10());
  observerInput.observe(document.body, { childList: true, subtree: true });
});
